module.exports = __webpack_public_path__ + "img/_www.ce8f2008.svg";